import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "./components/Layout";
import HomePage from "./pages/HomePage";
import GuidePage from "./pages/GuidePage";
import GuideDetailPage from "./pages/GuideDetailPage";
import StrategiePage from "./pages/StrategiePage";
import NotifichePage from "./pages/NotifichePage";
import ChecklistPage from "./pages/ChecklistPage";
import FaqPage from "./pages/FaqPage";
import AssistenzaPage from "./pages/AssistenzaPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="guide" element={<GuidePage />} />
          <Route path="guide/:slug" element={<GuideDetailPage />} />
          <Route path="guida" element={<Navigate to="/guide" replace />} />
          <Route path="strategie" element={<StrategiePage />} />
          <Route path="notifiche" element={<NotifichePage />} />
          <Route path="checklist" element={<ChecklistPage />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="assistenza" element={<AssistenzaPage />} />
          <Route path="*" element={<HomePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
